/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  FleetAlliance,
  FleetAllianceCreateInput,
  FleetAlliancesList,
  FleetAlliesParams,
  SchemaValidationErrorResponse,
  StandardError,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Fleet Allies
 */
export const fleetAllies = (
    fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetAlliesParams>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
params = toValue(params);

      return axiosClient<FleetAlliancesList>(
      {url: `/fleets/${fleetSlug}/allies`, method: 'GET',
        params, signal
    },
      );
    }




export const getFleetAlliesQueryKey = (fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetAlliesParams>,) => {
    return [
    'fleets',fleetSlug,'allies', ...(params ? [params] : [])
    ] as const;
    }


export const getFleetAlliesQueryOptions = <TData = Awaited<ReturnType<typeof fleetAllies>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetAlliesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetAllies>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetAlliesQueryKey(fleetSlug,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetAllies>>> = ({ signal }) => fleetAllies(fleetSlug,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetAllies>>, TError, TData>
}

export type FleetAlliesQueryResult = NonNullable<Awaited<ReturnType<typeof fleetAllies>>>
export type FleetAlliesQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Fleet Allies
 */

export function useFleetAllies<TData = Awaited<ReturnType<typeof fleetAllies>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetAlliesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetAllies>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetAlliesQueryOptions(fleetSlug,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Send Alliance Request
 */
export const createFleetAlliance = (
    fleetSlug: MaybeRefOrGetter<string>,
    fleetAllianceCreateInput: MaybeRefOrGetter<FleetAllianceCreateInput>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
fleetAllianceCreateInput = toValue(fleetAllianceCreateInput);

      return axiosClient<FleetAlliance>(
      {url: `/fleets/${fleetSlug}/allies`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: fleetAllianceCreateInput, signal
    },
      );
    }




export const getCreateFleetAllianceMutationKey = () => ['createFleetAlliance'] as const;

export const getCreateFleetAllianceMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFleetAlliance>>, TError,CreateFleetAllianceMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createFleetAlliance>>, TError,CreateFleetAllianceMutationVariables, TContext> => {

const mutationKey = getCreateFleetAllianceMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFleetAlliance>>, CreateFleetAllianceMutationVariables> = (props) => {
          const {fleetSlug,data} = props ?? {};

          return  createFleetAlliance(fleetSlug,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateFleetAllianceMutationResult = NonNullable<Awaited<ReturnType<typeof createFleetAlliance>>>
    export type CreateFleetAllianceMutationBody = FleetAllianceCreateInput
    export type CreateFleetAllianceMutationError = ErrorType<ValidationError | StandardError>
    export type CreateFleetAllianceMutationVariables = {fleetSlug: string;data: FleetAllianceCreateInput}

    /**
 * @summary Send Alliance Request
 */
export const useCreateFleetAlliance = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFleetAlliance>>, TError,CreateFleetAllianceMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createFleetAlliance>>,
        TError,
        CreateFleetAllianceMutationVariables,
        TContext
      > => {
      return useMutation(getCreateFleetAllianceMutationOptions(options), queryClient);
    }
    /**
 * @summary Fleet Alliance
 */
export const fleetAlliance = (
    fleetSlug: MaybeRefOrGetter<string>,
    allySlug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
allySlug = toValue(allySlug);

      return axiosClient<FleetAlliance>(
      {url: `/fleets/${fleetSlug}/allies/${allySlug}`, method: 'GET', signal
    },
      );
    }




export const getFleetAllianceQueryKey = (fleetSlug: MaybeRefOrGetter<string>,
    allySlug: MaybeRefOrGetter<string>,) => {
    return [
    'fleets',fleetSlug,'allies',allySlug
    ] as const;
    }


export const getFleetAllianceQueryOptions = <TData = Awaited<ReturnType<typeof fleetAlliance>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>,
    allySlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetAlliance>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetAllianceQueryKey(fleetSlug,allySlug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetAlliance>>> = ({ signal }) => fleetAlliance(fleetSlug,allySlug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined && toValue(allySlug) !== null && toValue(allySlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetAlliance>>, TError, TData>
}

export type FleetAllianceQueryResult = NonNullable<Awaited<ReturnType<typeof fleetAlliance>>>
export type FleetAllianceQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Fleet Alliance
 */

export function useFleetAlliance<TData = Awaited<ReturnType<typeof fleetAlliance>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>,
    allySlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetAlliance>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetAllianceQueryOptions(fleetSlug,allySlug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Withdraw a request, or end an alliance
 */
export const destroyFleetAlliance = (
    fleetSlug: MaybeRefOrGetter<string>,
    allySlug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
allySlug = toValue(allySlug);

      return axiosClient<void>(
      {url: `/fleets/${fleetSlug}/allies/${allySlug}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyFleetAllianceMutationKey = () => ['destroyFleetAlliance'] as const;

export const getDestroyFleetAllianceMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyFleetAlliance>>, TError,DestroyFleetAllianceMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyFleetAlliance>>, TError,DestroyFleetAllianceMutationVariables, TContext> => {

const mutationKey = getDestroyFleetAllianceMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyFleetAlliance>>, DestroyFleetAllianceMutationVariables> = (props) => {
          const {fleetSlug,allySlug} = props ?? {};

          return  destroyFleetAlliance(fleetSlug,allySlug,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyFleetAllianceMutationResult = NonNullable<Awaited<ReturnType<typeof destroyFleetAlliance>>>

    export type DestroyFleetAllianceMutationError = ErrorType<ValidationError | StandardError>
    export type DestroyFleetAllianceMutationVariables = {fleetSlug: string;allySlug: string}

    /**
 * @summary Withdraw a request, or end an alliance
 */
export const useDestroyFleetAlliance = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyFleetAlliance>>, TError,DestroyFleetAllianceMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyFleetAlliance>>,
        TError,
        DestroyFleetAllianceMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyFleetAllianceMutationOptions(options), queryClient);
    }
    /**
 * @summary Accept Alliance Request
 */
export const acceptFleetAlliance = (
    fleetSlug: MaybeRefOrGetter<string>,
    allySlug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
allySlug = toValue(allySlug);

      return axiosClient<FleetAlliance>(
      {url: `/fleets/${fleetSlug}/allies/${allySlug}/accept`, method: 'PUT', signal
    },
      );
    }




export const getAcceptFleetAllianceMutationKey = () => ['acceptFleetAlliance'] as const;

export const getAcceptFleetAllianceMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptFleetAlliance>>, TError,AcceptFleetAllianceMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof acceptFleetAlliance>>, TError,AcceptFleetAllianceMutationVariables, TContext> => {

const mutationKey = getAcceptFleetAllianceMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acceptFleetAlliance>>, AcceptFleetAllianceMutationVariables> = (props) => {
          const {fleetSlug,allySlug} = props ?? {};

          return  acceptFleetAlliance(fleetSlug,allySlug,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AcceptFleetAllianceMutationResult = NonNullable<Awaited<ReturnType<typeof acceptFleetAlliance>>>

    export type AcceptFleetAllianceMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type AcceptFleetAllianceMutationVariables = {fleetSlug: string;allySlug: string}

    /**
 * @summary Accept Alliance Request
 */
export const useAcceptFleetAlliance = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptFleetAlliance>>, TError,AcceptFleetAllianceMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof acceptFleetAlliance>>,
        TError,
        AcceptFleetAllianceMutationVariables,
        TContext
      > => {
      return useMutation(getAcceptFleetAllianceMutationOptions(options), queryClient);
    }
    /**
 * @summary Decline Alliance Request
 */
export const declineFleetAlliance = (
    fleetSlug: MaybeRefOrGetter<string>,
    allySlug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
allySlug = toValue(allySlug);

      return axiosClient<FleetAlliance>(
      {url: `/fleets/${fleetSlug}/allies/${allySlug}/decline`, method: 'PUT', signal
    },
      );
    }




export const getDeclineFleetAllianceMutationKey = () => ['declineFleetAlliance'] as const;

export const getDeclineFleetAllianceMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof declineFleetAlliance>>, TError,DeclineFleetAllianceMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof declineFleetAlliance>>, TError,DeclineFleetAllianceMutationVariables, TContext> => {

const mutationKey = getDeclineFleetAllianceMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof declineFleetAlliance>>, DeclineFleetAllianceMutationVariables> = (props) => {
          const {fleetSlug,allySlug} = props ?? {};

          return  declineFleetAlliance(fleetSlug,allySlug,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeclineFleetAllianceMutationResult = NonNullable<Awaited<ReturnType<typeof declineFleetAlliance>>>

    export type DeclineFleetAllianceMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DeclineFleetAllianceMutationVariables = {fleetSlug: string;allySlug: string}

    /**
 * @summary Decline Alliance Request
 */
export const useDeclineFleetAlliance = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof declineFleetAlliance>>, TError,DeclineFleetAllianceMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof declineFleetAlliance>>,
        TError,
        DeclineFleetAllianceMutationVariables,
        TContext
      > => {
      return useMutation(getDeclineFleetAllianceMutationOptions(options), queryClient);
    }
    /**
 * @summary Ignore Alliance Request
 */
export const ignoreFleetAlliance = (
    fleetSlug: MaybeRefOrGetter<string>,
    allySlug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
allySlug = toValue(allySlug);

      return axiosClient<FleetAlliance>(
      {url: `/fleets/${fleetSlug}/allies/${allySlug}/ignore`, method: 'PUT', signal
    },
      );
    }




export const getIgnoreFleetAllianceMutationKey = () => ['ignoreFleetAlliance'] as const;

export const getIgnoreFleetAllianceMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ignoreFleetAlliance>>, TError,IgnoreFleetAllianceMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof ignoreFleetAlliance>>, TError,IgnoreFleetAllianceMutationVariables, TContext> => {

const mutationKey = getIgnoreFleetAllianceMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof ignoreFleetAlliance>>, IgnoreFleetAllianceMutationVariables> = (props) => {
          const {fleetSlug,allySlug} = props ?? {};

          return  ignoreFleetAlliance(fleetSlug,allySlug,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type IgnoreFleetAllianceMutationResult = NonNullable<Awaited<ReturnType<typeof ignoreFleetAlliance>>>

    export type IgnoreFleetAllianceMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type IgnoreFleetAllianceMutationVariables = {fleetSlug: string;allySlug: string}

    /**
 * @summary Ignore Alliance Request
 */
export const useIgnoreFleetAlliance = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ignoreFleetAlliance>>, TError,IgnoreFleetAllianceMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof ignoreFleetAlliance>>,
        TError,
        IgnoreFleetAllianceMutationVariables,
        TContext
      > => {
      return useMutation(getIgnoreFleetAllianceMutationOptions(options), queryClient);
    }
